import Swal from 'sweetalert2';
import axios from "axios";
import config from "../../config";
import { clearStorage, isSSOlogin, getTokenDetails } from "../authToken";
import { tryRefreshToken } from "../refreshToken";

const jwtAxios = axios.create({
  headers: {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
  },
  baseURL: config.BASE_URL,
});

jwtAxios.interceptors.request.use(async (config) => {
  let tokenDetails = getTokenDetails();
  const accessToken = tokenDetails.accessToken;
  const accessTokenExpireTime = tokenDetails.accessTokenExpireTime;
  const refreshTokenExpireTime = tokenDetails.refreshTokenExpireTime;
  if (isSSOlogin()) {
  }
  else {
    // Check if refreshToken is expired
    if (refreshTokenExpireTime && new Date(refreshTokenExpireTime) <= new Date()) {
      await Swal.fire({
        position: 'center',
        icon: 'error',
        title: 'Session expired, Please re-login!!!',
        showConfirmButton: true,
        timer: 2000
      });
      clearStorage();
      window.location.href = '/';
      return config;
    }

    if (accessToken && accessTokenExpireTime && new Date(accessTokenExpireTime) <= new Date()) {
      await refreshTokenFn(tokenDetails)
    }
  }
  tokenDetails = getTokenDetails()
  if (tokenDetails && tokenDetails.accessToken)
    config.headers.Authorization = `Bearer ${tokenDetails.accessToken}`;
  return config;
});

jwtAxios.interceptors.response.use(
  (res) => res,
    async (err) => {
      if (err.response && err.response.data.statusCode === 403) {
      Swal.fire({
        position: 'center',
        icon: 'error',
        text: err.response.data.message,
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true
      });
      setTimeout(() => {
        clearStorage();
        window.location.href = '/';
      }, 3000);

      }
      else if (err.response && err.response.data.statusCode === undefined) {
            Swal.fire({
                position: 'center',
                icon: 'error',
                text: "Access denied",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true
            });
            setTimeout(() => {
                clearStorage();
                window.location.href = '/';
            }, 3000);

        }
    else if (err.response && (err.response.status === 401 || err.response.data.statusCode === 401)) {
      await Swal.fire({
        position: 'center',
        icon: 'error',
        text: 'Unauthorised. Attempting to resolve; if not resolved, relog again',
        showConfirmButton: true,
        timer: 3000,
        timerProgressBar: true
      })
      window.location.reload()
    }
    else if (err.response && err.response.data.statusCode === 400 && err.response.data.errors?.length > 0) {
      Swal.fire({
        position: 'center',
        icon: 'error',
        text: err.response.data.errors.map((item, index) => item),
        showConfirmButton: true,
        timer: 3000,
        timerProgressBar: true
      });
    }
      else {
      Swal.fire({
        position: 'center',
        icon: 'error',
        text: err.response.data?.message,
        showConfirmButton: true,
        timer: 3000,
        timerProgressBar: true
      })
    }
    if (err.request.responseURL.includes('/api/files') && err.response.status === 400 && err.response.data.errors.join(',').includes('already exist'))
      return Promise.resolve({ data: err.response.data });
    else
      return Promise.resolve(err.response.status + "~" + err.message);
  }
);

export const setAuthToken = (tokenDetails) => {
  if (tokenDetails) {
    jwtAxios.defaults.headers.common.Authorization = `Bearer ${tokenDetails.accessToken}`;
    localStorage.setItem('tokenDetails', JSON.stringify(tokenDetails));
  } else {
    delete jwtAxios.defaults.headers.common.Authorization;
    localStorage.removeItem('tokenDetails');
  }
};

export const refreshTokenFn = async (tokenDetails) => {
  try {
    const { data } = await tryRefreshToken();
    const { accessToken: newAccessToken, accessTokenExpireTime: newAccessTokenExpireTime } = data.result;
    tokenDetails.accessToken = newAccessToken;
    tokenDetails.accessTokenExpireTime = newAccessTokenExpireTime;
    localStorage.setItem('tokenDetails', JSON.stringify(tokenDetails));
  }
  catch {
    await Swal.fire({
      position: 'center',
      icon: 'error',
      title: 'Session expired, Please re-login!!!',
      showConfirmButton: true,
      timer: 2000
    });
    clearStorage();
    window.location.href = '/';
  }
}

export default jwtAxios;
